import { BookingMinimal, Money, StorageObjectGroup, TireOfferMinimal, UserMinimalInfo } from '../..';
import { StorageFacility } from '../storage';

export interface InventoryOrder {
  createdAt: string;
  description: string;
  id: number;
  orderNumber: string;
  price: Money;
  status: InventoryOrderStatus;
  trackingNumber: string;
  updatedAt: string;
  vatPercentage: number;
  estimatedDeliveryDate?: string;
  storageFacility: StorageFacility;
  storageObjectGroup?: StorageObjectGroup;
  tireQuote?: TireOfferMinimal;
}

export interface InventoryOrderForTireQuote {
  id: number;
  orderNumber: string;
  price: Money;
  status: InventoryOrderStatus;
  trackingNumber: string;
  tireQuote: TireOfferMinimal;
  createdAt: string;
  updatedAt: string;
  estimatedDeliveryDate?: string;
  upcomingBooking?: BookingMinimal;
}

export const inventoryOrderStatuses = {
  ORDERED_AT_SUPPLIER: 'ORDERED_AT_SUPPLIER',
  IN_TRANSIT: 'IN_TRANSIT',
  RECEIVED: 'RECEIVED',
  INVENTORY_IN_STOCK: 'INVENTORY_IN_STOCK'
} as const;

export const inventoryOrderStatusesToLabel = {
  ORDERED_AT_SUPPLIER: 'Ordered at supplier',
  IN_TRANSIT: 'In transit',
  RECEIVED: 'Received',
  INVENTORY_IN_STOCK: 'Inventory in stock'
} as const;

export type InventoryOrderStatusType = (typeof inventoryOrderStatuses)[keyof typeof inventoryOrderStatuses];

export const inventoryOrderStatusesOptions = Object.values(inventoryOrderStatuses).map((status) => ({
  label: inventoryOrderStatusesToLabel[status],
  value: status
}));

export interface InventoryOrderStatus {
  id: number;
  name: InventoryOrderStatusType;
  createdBy: UserMinimalInfo;
  status: InventoryOrderStatusType;
  quoteId: number;

  createdAt: string;
}

export interface InventoryOrderCreationPayload {
  description?: string;
  orderNumber: string;
  price: Money;
  trackingNumber?: string;
  vatPercentage: number;
  status: InventoryOrderStatusType;
  storageFacilityId: number;
  estimatedDeliveryDate?: string;
}
